<sd-ymap class="map" (created)="onMapCreated($event)"></sd-ymap>
